import React, {useState, useRef} from "react";
import 'react-calendar/dist/Calendar.css';
import {Card, CardBody, CardHeader, CardTitle, Col, Row} from "reactstrap";
import {
	TextField,
	Typography,
	Grid,
	Box,
	Radio,
	RadioGroup,
	FormControlLabel,
	makeStyles,
	createTheme,
	useMediaQuery, Button,
} from '@material-ui/core';
import IconButton from "@mui/material/IconButton";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment-jalali";
import FormControl from "@mui/material/FormControl";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import NotificationAlert from "react-notification-alert";

const cardStyle={
	backgroundColor:'#ffffff',
	borderRadius:'25px',
	padding:'10px',
}

function AddNewPatient() {

	// add Notification AMS:
	const notificationAlertRef = React.useRef(null);

	const showNotification = (message, type) => {
		const options = {
			place: "tc",
			message: (
				<div style={{ textAlign: "center" }}>
					<div>{message}</div>
				</div>
			),
			type: type,
			icon: "tim-icons icon-bell-55",
			autoDismiss: 3,
		};
		notificationAlertRef.current.notificationAlert(options);
	};

	const englishToPersianNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};
   ///////// ADD by AMS to translate errors
	const translateField = (fieldName) => {
        // Mapping of English field names to Persian translations
        const fieldTranslations = {
            injury_type: "نوع آسیب",
            insurance_company: "نام بیمه",
            last_name: "نام خانوادگی",
            name: "نام",
            phone_number: "تلفن"
        };

        // Return the translated field name if it exists in the mapping, otherwise return the original name
        return fieldTranslations[fieldName] || fieldName;
    }

	const JalaliMoment = require('jalali-moment');
	const persianToEnglishNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of Persian digits to English digits
		const digitMap = {
			'۰': '0',
			'۱': '1',
			'۲': '2',
			'۳': '3',
			'۴': '4',
			'۵': '5',
			'۶': '6',
			'۷': '7',
			'۸': '8',
			'۹': '9',
		};

		// Convert Persian numbers in the input to English numbers
		const convertedString = input.toString().replace(/[۰-۹]/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToGregorianAndEnglish = (persianDate) => {
		// Convert Persian (Solar) date to Gregorian date
		if (!persianDate) persianDate = '۱۳۹۹/۰۱/۰۱'; // Replace with your Persian date
		const englishNumbers = persianToEnglishNumbers(persianDate);
		const gregorianDate = JalaliMoment(englishNumbers, 'jYYYY/jMM/jDD').format('YYYY-MM-DD');

		// Convert Persian numbers to English numbers
		//const englishNumbers = persianToEnglishNumbers(gregorianDate);

		return gregorianDate;
	};

	const [fileHanlde, setFileHanlde] = useState(0); // if 0 > no file if 1 > image if 2 > file if 3 > file and image

	const options = ['شانه','زانو', 'کمر', 'گردن', 'لگن', 'آرنج', 'مچ دست', 'مچ پا', 'مفصل ران','کتف', 'شکم', 'فک', 'قفسه سینه', 'توراسیک'];
	const useStyles = makeStyles((theme) => ({
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
	}));
	const classes = useStyles();
	const theme = createTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

	const [firstName, setFirstName] = useState();
	const [lastName, setLastName] = useState();
	const [sex, setSex] = useState();
	const [birthDate, setBirthDate] = useState();
	const [id, setId] = useState();
	const [insuranceTitle, setInsuranceTitle] = useState();
	const [insuranceNumber, setInsuranceNumber] = useState();

	const [address, setAddress] = useState();
	const [phone, setPhone] = useState();
	const [email, setEmail] = useState();
	const [postalCode, setPostalCode] = useState();

	const [diseaseBackground, setDiseaseBackground] = useState();
	const [injuryType, setInjuryType] = useState();

	const [height, setHeight] = useState();
	const [weight, setWeight] = useState();
	const [blodType, setBlodType] = useState();

	const [documentNote, setDocumentNote] = useState();
	const [doctorNote, setDoctorNote] = useState();

	const [patientID, setPatientID] = useState(Cookies.get('patientID'));
	const [data, setData] = useState([{}]);

	const [Image, setImage] = useState([]);
	const fileInputRefImage = useRef(null);

	const [files, setFiles] = useState([]);
	const fileInputRef = useRef(null);

	const handleChange = (event) => {
		setInjuryType(event.target.value);
	};

	const handleConfirm = () => {
		    showNotification("در انتظار پاسخ از سامانه، لطفا منتظر بمانید", "info");

			const formData = new FormData();

			const fields = {
				name: firstName,
				last_name: lastName,
				phone_number: persianToEnglishNumbers(phone),
				email: email,
				gender: sex ? sex : 'f',
				birth_date: convertToGregorianAndEnglish(birthDate),
				address: address,
				insurance_number: persianToEnglishNumbers(insuranceNumber),
				insurance_company: insuranceTitle,
				injury_description: diseaseBackground,
				injury_type: injuryType,
				blood_type: blodType,
				height: height,
				weight: weight,
				bio: doctorNote,
			};
		
			for (const [fieldName, value] of Object.entries(fields)) {
				if (value !== undefined && value !== null) {
					formData.append(fieldName, typeof value === 'string' ? persianToEnglishNumbers(value) : value);
				}
			}
		
			if (fileHanlde === 1 || fileHanlde === 3) {
				formData.append("photo", Image);
			}
		
			if (fileHanlde === 2 || fileHanlde === 3) {
				formData.append("medical_documents", files);
			}

		// Send the post request
		axios.post(`https://back.actelmon.ir/api/doctor/add-patient/`, formData, {
			headers: {
				Authorization: `${Cookies.get('token')}`,
				'Content-Type': 'multipart/form-data', // Specify the content type
			},
		})
			.then((response) => {
				// Handle success
				console.log('Data posted successfully PatientEditProfile:', response.data);
				console.log('mydata', formData);

				// Create a text content with username and password
				const welText = `نام کاربری و کلمه عبور بیمار جهت ورود به سامانه به شرح زیر است:`
				const textContent = `Username: ${response.data.phone_number}\nPassword: ${response.data.password}`;

				// Create a Blob containing the text content
				const blob = new Blob([`${welText} \n  ${textContent}`], { type: 'text/plain' });

				// Create a link element and trigger the download
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = `Patient-${response.data.phone_number}.txt`;
				showNotification("ّبیمار با موفقیت ایجاد شد، اطلاعات کاربری دانلود شد", "success");

				link.click();

				// Clean up
				URL.revokeObjectURL(link.href);
				Cookies.set('patientID', response.data.id);
				window.location.href = '/rtl/dashboard';
			})
			.catch((error) => {
				console.log('Data PatientEditProfile', error);
				console.error('Error fetching data PatientEditProfile:', error);
				// showNotification("لطفا تمامی فیلدهای * دار پرکنید", "danger");
								// Parsing the error response and translating field names
				const errors = Object.entries(error.response.data).map(([field, messages]) => {
					const translatedFieldName = translateField(field);
					return `${translatedFieldName}`;
				});
				
				// Constructing the notification message
				const notificationMessage = `\n فیلدهای ${errors.join(' - ')} را بررسی کنید`;

				// Showing the notification
				showNotification(notificationMessage, "danger");
				
			});
	};


	const handleImageInput = (e) => {
		const selectedFiles = Array.from(e.target.files);
		setImage(selectedFiles[0]);
		setFileHanlde( fileHanlde === 0 ? 1 : 3 );
	};

	const handleDropImage = (e) => {
		e.preventDefault();
		const droppedFiles = Array.from(e.dataTransfer.files);
		setImage(droppedFiles[0]);
		setFileHanlde( fileHanlde === 0 ? 1 : 3 );
	};

	const handleDragOverImage = (e) => {
		e.preventDefault();
	};



	const handleFileInput = (e) => {
		const selectedFiles = Array.from(e.target.files);
		setFiles(selectedFiles[0]);
		setFileHanlde( fileHanlde === 0 ? 2 : 3 );
	};

	const handleDrop = (e) => {
		e.preventDefault();
		const droppedFiles = Array.from(e.dataTransfer.files);
		setFiles(droppedFiles[0]);
		setFileHanlde( fileHanlde === 0 ? 2 : 3 );
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<NotificationAlert ref={notificationAlertRef} />
			<div className="content">

					<Col lg="12" sm="12" style={{backgroundColor:'white',padding:'30px',borderRadius:'10px'}}>

						<Row lg="11" sm="11">

							<Col lg="8" sm="8">

								<Card style={cardStyle} >
									<CardHeader className="text-right">
										<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات شخصی</CardTitle>
									</CardHeader>

									<CardBody>
										{/*first name*/}
										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

											<Grid item lg={6} xs={12}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														نام*
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={firstName}
													           onChange={(event) => {setFirstName(event.target.value)}} />
												</Grid>
											</Grid>

											<Grid item lg={6} xs={12}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														نام خانوادگی*
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={lastName}
													           onChange={(event) => {setLastName(event.target.value)}} />
												</Grid>
											</Grid>

										</Grid>

										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

											<Grid item xs={6}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														جنسیت*
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<FormControl fullWidth>
														<Select
															labelId="demo-simple-select-label"
															value={sex === 'm' ? 0 : 1}
															onChange={
																(event) => {
																	event.target.value === 1 ? setSex('f') : setSex('m')
																}
															}
															style={{height:'55px',textAlign:'right',direction:'rtl'}}
														>
															<MenuItem value={0}>مرد</MenuItem>
															<MenuItem value={1}>زن</MenuItem>

														</Select>
													</FormControl>
												</Grid>
											</Grid>

											<Grid item xs={6}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														تاریخ تولد*
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={birthDate}
													           onChange={(event) => {setBirthDate(englishToPersianNumbers(event.target.value))}} />
												</Grid>
											</Grid>

										</Grid>

										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

											<Grid item xs={6}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														نام بیمه*
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={insuranceTitle}
													           onChange={(event) => {setInsuranceTitle(event.target.value)}} />
												</Grid>
											</Grid>

											<Grid item xs={6}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														شماره بیمه
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={insuranceNumber}
													           onChange={(event) => {setInsuranceNumber(englishToPersianNumbers(event.target.value))}} />
												</Grid>
											</Grid>

										</Grid>

										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

										</Grid>

									</CardBody>
								</Card>

								<Card style={cardStyle} >
									<CardHeader className="text-right">
										<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات تماس</CardTitle>
									</CardHeader>

									<CardBody>
										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

											<Grid item xs={12}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														آدرس
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={address}
													           onChange={(event) => {setAddress(event.target.value)}} />
												</Grid>
											</Grid>

										</Grid>

										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

											<Grid item lg={6} xs={12}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														تلفن*
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={phone}
													           onChange={(event) => {setPhone(englishToPersianNumbers(event.target.value))}} />
												</Grid>
											</Grid>

											<Grid item lg={6} xs={12}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														ایمیل
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={email}
													           onChange={(event) => {setEmail(event.target.value)}} />
												</Grid>
											</Grid>

										</Grid>

										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>
										</Grid>

									</CardBody>
								</Card>

								<Card style={cardStyle} >
									<CardHeader className="text-right">
										<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>اطلاعات بیماری</CardTitle>
									</CardHeader>

									<CardBody>
										<Grid container
										      spacing={5}
										      style={{direction:'rtl', textAlign:'right'}}
										      alignItems="center"
										>

											<Grid item xs={12}>
												<Grid item xs={12} >
													<Typography gutterBottom>
														سابقه بیماری (فشارخون، دیابت، ...)
													</Typography>
												</Grid>
												<Grid item xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={diseaseBackground}
													           onChange={(event) => {setDiseaseBackground(event.target.value)}} />
												</Grid>
											</Grid>

										</Grid>

									</CardBody>
								</Card>

								<Card style={cardStyle} >
									<CardHeader className="text-right">
										<CardTitle tag="h4" style={{color:'#D0576E',fontWeight:'bold'}}>نوع آسیب*</CardTitle>
									</CardHeader>

									<CardBody>
										<RadioGroup
											aria-label="options"
											name="options"
											value={injuryType}
											onChange={handleChange}
											row={!isSmallScreen} // Display as a row on larger screens
											style={{marginRight:'10px'}}
										>
											{options.map((option) => (
												<FormControlLabel
													key={option}
													value={option}
													control={<Radio color="primary" />}
													label={option}
													labelPlacement={isSmallScreen ? 'end' : 'start'}
												/>
											))}
										</RadioGroup>
									</CardBody>
								</Card>


							</Col>

							<Col lg="4" sm="4">

								{/* <Grid container spacing={2} justifyContent="center" alignItems="center">
									<Grid item style={{marginBottom:'40px'}}>
											<Button variant="contained"
											        style={{backgroundColor:'#138C97',color:'white'}}
											        startIcon={<BookmarksIcon sx={{marginLeft:'10px', color:'white'}} />}
											        onClick={handleConfirm}
											>
												ثبت
											</Button>
									</Grid>
								</Grid> */}

								<Card style={{...cardStyle,backgroundColor:'#eeeeee'}} >
									<CardHeader className="text-center">
										<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>عکس پروفایل</CardTitle>
									</CardHeader>

									<CardBody>
										<Grid container alignItems="center" justifyContent="center">
											<Grid item>
												<div
													onDrop={handleDropImage}
													onDragOver={handleDragOverImage}
													onClick={() => fileInputRefImage.current.click()} // Trigger file input
													style={{
														border: '2px dashed #ccc',
														borderRadius: '5px',
														padding: '20px',
														textAlign: 'center',
														backgroundColor: 'white',
														cursor: 'pointer',
													}}
												>
													<input
														type="file"
														accept="image/*" // Define accepted file types
														style={{ display: 'none' }}
														ref={fileInputRefImage} // Create a reference to the file input
														onChange={handleImageInput}
													/>
													<CloudUploadOutlinedIcon
														sx={{ color: "#6e6e6e", fontSize:'50px'}}
													/>
													<br/>
													<Typography variant="caption">فایل را در اینجا بکشید و رها کنید و یا کلیک کنید. نوع فایل یکی از انواع png, jpeg, jpg و حجم فایل ارسالی حداکثر 800 کیلوبایت باشد.</Typography>
														<Box>
															<Typography>{Image.name}</Typography>
														</Box>
												</div>
											</Grid>
										</Grid>
									</CardBody>
								</Card>

								<Card style={{...cardStyle,backgroundColor:'#eeeeee'}} >
									<CardHeader className="text-center">
										<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>مدارک پزشکی</CardTitle>
									</CardHeader>

									<CardBody>
										<Grid container spacing={5} alignItems="center" justifyContent="center">

											<Grid item>
												<div
													onDrop={handleDrop}
													onDragOver={handleDragOver}
													onClick={() => fileInputRef.current.click()} // Trigger file input
													style={{
														border: '2px dashed #ccc',
														borderRadius: '5px',
														padding: '20px',
														textAlign: 'center',
														backgroundColor: 'white',
														cursor: 'pointer',
													}}
												>
													<input
														type="file"
														ccept=".pdf, image/*" // Define accepted file types
														style={{ display: 'none' }}
														ref={fileInputRef} // Create a reference to the file input
														onChange={handleFileInput}
													/>
													<CloudUploadOutlinedIcon
														sx={{ color: "#6e6e6e", fontSize:'50px'}}
													/>
													<br/>
													<Typography variant="caption">فایل را در اینجا بکشید و رها کنید و یا کلیک کنید. نوع فایل یکی از انواع png, jpeg, jpg و حجم فایل ارسالی حداکثر 800 کیلوبایت باشد.</Typography>
														<Box>
															<Typography>{files.name}</Typography>
														</Box>
												</div>


											</Grid>

										</Grid>
									</CardBody>
								</Card>

								<Card style={{...cardStyle,backgroundColor:'#eeeeee'}} >
									<CardHeader className="text-center">
										<CardTitle tag="h4" style={{color:'#EBAB60',fontWeight:'bold'}}>مشخصات فیزیکی</CardTitle>
									</CardHeader>

									<CardBody>
										<Grid container alignItems="center" justifyContent="center"
										      style={{backgroundColor:'white', borderRadius:'5px', padding:"20px"}}>

											<Grid container spacing={5} style={{textAlign:'right'}} alignItems="center">

												<Grid item lg={5} xs={12}>
													<Typography gutterBottom>
														قد (سانتی متر)
													</Typography>
												</Grid>
												<Grid item lg={7} xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={height}
													           onChange={(event) => {setHeight(englishToPersianNumbers(event.target.value))}} />
												</Grid>

											</Grid>

											<Grid container spacing={5} style={{textAlign:'right', marginTop:'5px'}} alignItems="center">

												<Grid item lg={5} xs={12}>
													<Typography gutterBottom>
														وزن (کیلوگرم)
													</Typography>
												</Grid>
												<Grid item lg={7} xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={weight}
													           onChange={(event) => {setWeight(englishToPersianNumbers(event.target.value))}} />
												</Grid>

											</Grid>

											<Grid container spacing={5} style={{textAlign:'right', marginTop:'5px'}} alignItems="center">

												<Grid item lg={5} xs={12}>
													<Typography gutterBottom>
														گروه خونی
													</Typography>
												</Grid>
												<Grid item lg={7} xs={12}>
													<TextField id="outlined-basic"
													           variant="outlined"
													           fullWidth={true}
													           value={blodType}
													           onChange={(event) => {setBlodType(event.target.value)}} />
												</Grid>

											</Grid>

											<Grid container spacing={5} style={{textAlign:'right', marginTop:'5px'}} alignItems="center">
												<IconButton aria-label="edit" size="large" disabled={true}>
													<AddBoxOutlinedIcon fontSize="inherit" sx={{color:"#b7b7b7"}} />
													<Typography gutterBottom style={{color:'#b7b7b7', padding:'10px'}}>
														افزودن
													</Typography>
												</IconButton>
											</Grid>

										</Grid>
									</CardBody>
								</Card>

							</Col>

						</Row>

						<Row lg="1" sm="1" style={{backgroundColor:'white',borderRadius:'10px'}}>

							<Col lg="12" sm="12">
								<Card style={cardStyle} >
									<CardHeader className="text-right">
										<CardTitle tag="h4" style={{color:'#138C97',fontWeight:'bold'}}>یادداشت پزشک</CardTitle>
									</CardHeader>

									<CardBody>
										<Grid container style={{direction:'rtl', textAlign:'right'}} alignItems="center">
											<Grid item xs={12}>
												<TextField id="outlined-basic"
												           variant="outlined"
												           fullWidth
												           placeholder="در صورت تمایل یک یادداشت اضافه کنید (شرح آسیب یا بیماری)"
												           onChange={(event) => {setDoctorNote(event.target.value)}} />
											</Grid>
										</Grid>
									</CardBody>
								</Card>
							</Col>
						</Row>

						<Grid item xs={12}>
										<Grid container style={{ direction: 'rtl', textAlign: 'right' }} >

											<Grid item xs={11}>

											</Grid>

											<Grid item lg={1} xs={12} style={{paddingRight:'30px', paddingLeft:'30px'}}>
									
											<Button variant="contained"
											        style={{backgroundColor:'#138C97',color:'white',width:"100%"}}
											        startIcon={<BookmarksIcon sx={{marginLeft:'10px', color:'white'}} />}
											        onClick={handleConfirm}
											>
												ثبت
											</Button>

											</Grid>


										</Grid>
						</Grid>
					</Col>
			</div>

		</>
	);
}

export default AddNewPatient;
